window.BOLD = window.BOLD || {};
window.BOLD.subscriptions = window.BOLD.subscriptions || {};
window.BOLD.subscriptions.config = window.BOLD.subscriptions.config || {};

window.BOLD.subscriptions.config.internationalizationFallbackLanguage = 'de';

window.BOLD.subscriptions.config.internationalization = {
  de: {
    translation: {
      // 🔐 Passwortloser Login
      passwordlessLoginSecured: 'Deine Daten sind sicher bei uns 🔒',
      passwordlessLoginHeader: 'Login ohne Passwort',
      passwordlessLoginDescription: 'Wir senden dir einen einmaligen Login-Link per E-Mail.',
      passwordlessLoginInputLabel: 'Deine E-Mail-Adresse eingeben',
      passwordlessLoginInputPlaceholder: 'E-Mail-Adresse',
      passwordlessLoginButtonLabel: 'Jetzt Login-Link anfordern',
      passwordlessLoginSubmitLabel: 'Login-Link senden',
      passwordlessLoginSuccessHeader: 'Fast geschafft!',
      passwordlessLoginSuccessDescription: 'Wir haben dir soeben einen Login-Link geschickt. Bitte überprüfe dein E-Mail-Postfach (inkl. Spam).',
      passwordlessLoginSuccessFooter: 'Du kannst dieses Fenster schließen, sobald du eingeloggt bist.',
      passwordlessLoginSuccessMessage: 'Bitte überprüfe dein E-Mail-Postfach!',
      passwordlessLoginErrorMessage: 'Hoppla! Etwas ist schief gelaufen. Versuch es nochmal.',

      // 👤 Kontoinformationen
      accountInfoTitle: "Kontoinformationen",
      accountInfoMessage: "Aktualisiere deine persönlichen Daten.",
      accountInfoNameLabel: "Name",
      accountInfoEmailLabel: "E-Mail-Adresse",
      accountInfoPhoneNumberLabel: "Telefonnummer",
      AccountInfoEditButton: "Bearbeiten",
      accountInfoEditButton: "Bearbeiten",

      // 🧾 Aktive Abos & Übersicht
      activeSubscriptionsTitle: "Aktive Abonnements",
      activeSubscriptionsSubtitle: "Hier findest du alle laufenden Abonnements.",
      noActiveSubscriptionsMessage: "Du hast derzeit keine aktiven Abonnements.",
      subscriptionSummarySubscriptionTitle: "Abo-Details",
      subscriptionSummaryNextOrderTitle: "Nächste Lieferung",
      subscriptionSummaryEditFutureOrderButton: "Zukünftige Lieferung bearbeiten",
      subscriptionSummaryProductsTitle: "Produkte",
      subscriptionSummaryPaymentInfoTitle: "Zahlungsmethode",
      subscriptionSummaryOrderFrequencyTitle: "Lieferintervall",
      subscriptionSummaryChangeFrequencyButton: "Intervall ändern",
      subscriptionSummaryShippingAddressTitle: "Lieferadresse",
      subscriptionSummarySubscriptionPausedMessage: "Dieses Abo ist aktuell pausiert.",
      subscriptionSummaryResumeFutureOrdersButton: "Abo fortsetzen",
      subscriptionSummaryDiscountCodeTitle: "Rabattcode",
      ADDPRODUCTSBUTTON: "Produkte hinzufügen",

      // 💳 Zahlungsbereich
      paymentPanelTitle: "Zahlungsinformationen",
      paymentPanelEmailUpdateFlowTitle: "Zahlungsdaten aktualisieren",
      paymentPanelEmailUpdateFlowCreditCardDetails: "Kreditkartendetails",
      paymentPanelEmailUpdateFlowBillingAddressTitle: "Rechnungsadresse",
      paymentPanelEmailUpdateFlowChangePaymentDetails: "Zahlungsdetails ändern",
      PAYMENTPANELEMAILUPDATEFLOWCHANGEPAYMENTBUTTON: "Zahlungsdaten speichern",
      paymentPanelEmailUpdateFlowChangePaymentButton: "Zahlungsmethode aktualisieren",

      // 📦 Adresse & Versand
      addressPanelTitle: "Adresse",
      addressPanelShippingMethodLabel: "Versandart",
      panelEditText: "Bearbeiten",
      addressPanelShippingAddressTitle: "Lieferadresse",
      "Edit": "Bearbeiten",

      // 📋 Produkte
      productsPanelTitle: "Produkte im Abo",
      productsPanelLineItemDetailQuantity: "Menge",

      // 📅 Kommende Lieferungen
      manageUpcomingOrdersPanelTitle: "Zukünftige Lieferungen",
      productsPanelDetailsActionsSwapButton: "Produkt tauschen",
      manageUpcomingOrdersPanelUpcomingOrdersTitle: "Geplante Bestellungen",
      manageUpcomingOrdersPanelChangesAffectFutureOrdersMessage: "Diese Änderung betrifft alle zukünftigen Bestellungen.",
      manageUpcomingOrdersPanelPauseFutureOrdersButton: "Zukünftige Lieferungen pausieren",
      MANAGEUPCOMINGORDERSPANELPAUSEFUTUREORDERSBUTTON: "Zukünftige Lieferungen pausieren",
      manageUpcomingOrdersPanelOrderDateTitle: "Lieferdatum",
      futureOrderDate: "Zukünftiges Lieferdatum",
      manageUpcomingOrdersPanelSkipShipmentFlowSkipShipmentButton: "Lieferung überspringen",
      manageUpcomingOrdersPanelProductTitle: "Produkt",
      "Pause future orders": "Zukünftige Lieferungen pausieren",
      changeNextOrderResumedSuccessMessage: "Deine Abo-Lieferungen wurden erfolgreich fortgesetzt.",

      // 📜 Bestellverlauf
      orderHistoryPanelTitle: "Bestellverlauf",
      orderHistoryPanelPricesDiscountsApplyMessage: "Rabatte wurden auf diese Bestellung angewendet.",
      orderHistoryPanelOrderIdColumn: "Bestellnummer",
      orderHistoryPanelSubtotalColumn: "Zwischensumme",
      orderHistoryPanelTaxColumn: "Steuer",
      orderHistoryPanelShippingColumn: "Versand",
      orderHistoryPanelTotalColumn: "Gesamtsumme",
      orderHistoryPanelDateCreatedColumn: "Bestelldatum",

      // 🎁 Rabatt
      "Discount code": "Rabattcode",
      "No discount applied": "Kein Rabatt angewendet",
      "Add discount": "Rabatt hinzufügen",

      // ❌ Kündigung
      cancelPanelTitle: "Abo kündigen",
      cancelPanelAlertMessage: "Bist du sicher, dass du dein Abonnement kündigen möchtest?",
      CANCELPANELCANCELSUBSCRIPTIONFLOWCANCELSUBSCRIPTIONBUTTON: "Abonnement kündigen",
      cancelPanelCancelSubscriptionFlowCancelSubscriptionButton: "Abo beenden",
      cancelPanelCancelSubscriptionFlowWarningHeaderMessage: "Das Beenden deines Abos hat Auswirkungen auf zukünftige Lieferungen.",
      cancelPanelCancelSubscriptionFlowReactivateSubscriptionMessage: "Du kannst dein Abo jederzeit wieder aktivieren.",
      cancelPanelCancelSubscriptionFlowKeepSubscriptionButton: "Abo behalten",
      cancelPanelCancelSubscriptionFlowCancelSubscriptionConfirmationButton: "Abo jetzt kündigen",
      cancelSubscriptionSuccessMessage: "Dein Abonnement wurde erfolgreich gekündigt.",

      // 💤 Inaktive Abos
      viewInactiveSubscriptionsButton: "Inaktive Abos anzeigen",
      hideInactiveSubscriptionsButton: "Inaktive Abos ausblenden",
      viewInactiveSubscriptionsTitle: "Inaktive Abonnements",
      viewInactiveSubscriptionsMessage: "Hier findest du Abos, die du pausiert oder beendet hast.",
      inactiveSubscriptionsTitle: "Inaktive Abonnements",
      inactiveSubscriptionName: "Inaktives Abo",
      inactiveSubscriptionsCount: "{{count}} inaktive Abonnements",
      reactivateSubscriptionButton: "Abo reaktivieren"
    }
  },
  en: {
    translation: {
      passwordlessLoginSecured: 'Your data is safe with us 🔒',
      passwordlessLoginHeader: 'Passwordless Login',
      passwordlessLoginDescription: 'We will send you a one-time login link via email.',
      passwordlessLoginInputLabel: 'Enter your email address',
      passwordlessLoginInputPlaceholder: 'Email address',
      passwordlessLoginButtonLabel: 'Request login link',
      passwordlessLoginSubmitLabel: 'Send login link',
      passwordlessLoginSuccessHeader: 'Almost there!',
      passwordlessLoginSuccessDescription: 'We’ve just sent you a login link. Please check your email inbox (including spam).',
      passwordlessLoginSuccessFooter: 'You can close this window once you are logged in.',
      passwordlessLoginSuccessMessage: 'Please check your email inbox!',
      passwordlessLoginErrorMessage: 'Oops! Something went wrong. Please try again.',
      accountInfoTitle: "Account Information",
      accountInfoMessage: "Update your personal information.",
      accountInfoNameLabel: "Name",
      accountInfoEmailLabel: "Email address",
      accountInfoPhoneNumberLabel: "Phone number",
      AccountInfoEditButton: "Edit",
      accountInfoEditButton: "Edit",
      activeSubscriptionsTitle: "Active Subscriptions",
      activeSubscriptionsSubtitle: "Here you can see all your active subscriptions.",
      noActiveSubscriptionsMessage: "You currently have no active subscriptions.",
      subscriptionSummarySubscriptionTitle: "Subscription Details",
      subscriptionSummaryNextOrderTitle: "Next Delivery",
      subscriptionSummaryEditFutureOrderButton: "Edit Future Delivery",
      subscriptionSummaryProductsTitle: "Products",
      subscriptionSummaryPaymentInfoTitle: "Payment Method",
      subscriptionSummaryOrderFrequencyTitle: "Delivery Interval",
      subscriptionSummaryChangeFrequencyButton: "Change Interval",
      subscriptionSummaryShippingAddressTitle: "Shipping Address",
      subscriptionSummarySubscriptionPausedMessage: "This subscription is currently paused.",
      subscriptionSummaryResumeFutureOrdersButton: "Resume Subscription",
      subscriptionSummaryDiscountCodeTitle: "Discount Code",
      ADDPRODUCTSBUTTON: "Add Products",
      paymentPanelTitle: "Payment Information",
      paymentPanelEmailUpdateFlowTitle: "Update Payment Details",
      paymentPanelEmailUpdateFlowCreditCardDetails: "Credit Card Details",
      paymentPanelEmailUpdateFlowBillingAddressTitle: "Billing Address",
      paymentPanelEmailUpdateFlowChangePaymentDetails: "Change Payment Details",
      PAYMENTPANELEMAILUPDATEFLOWCHANGEPAYMENTBUTTON: "Save Payment Data",
      paymentPanelEmailUpdateFlowChangePaymentButton: "Update Payment Method",
      addressPanelTitle: "Address",
      addressPanelShippingMethodLabel: "Shipping Method",
      panelEditText: "Edit",
      addressPanelShippingAddressTitle: "Shipping Address",
      "Edit": "Edit",
      productsPanelTitle: "Subscription Products",
      productsPanelLineItemDetailQuantity: "Quantity",
      manageUpcomingOrdersPanelTitle: "Upcoming Deliveries",
      productsPanelDetailsActionsSwapButton: "Swap Product",
      manageUpcomingOrdersPanelUpcomingOrdersTitle: "Scheduled Orders",
      manageUpcomingOrdersPanelChangesAffectFutureOrdersMessage: "This change affects all future orders.",
      manageUpcomingOrdersPanelPauseFutureOrdersButton: "Pause Future Deliveries",
      MANAGEUPCOMINGORDERSPANELPAUSEFUTUREORDERSBUTTON: "Pause Future Deliveries",
      manageUpcomingOrdersPanelOrderDateTitle: "Delivery Date",
      futureOrderDate: "Future Delivery Date",
      manageUpcomingOrdersPanelSkipShipmentFlowSkipShipmentButton: "Skip Delivery",
      manageUpcomingOrdersPanelProductTitle: "Product",
      "Pause future orders": "Pause Future Deliveries",
      changeNextOrderResumedSuccessMessage: "Your subscription deliveries have been successfully resumed.",
      orderHistoryPanelTitle: "Order History",
      orderHistoryPanelPricesDiscountsApplyMessage: "Discounts were applied to this order.",
      orderHistoryPanelOrderIdColumn: "Order Number",
      orderHistoryPanelSubtotalColumn: "Subtotal",
      orderHistoryPanelTaxColumn: "Tax",
      orderHistoryPanelShippingColumn: "Shipping",
      orderHistoryPanelTotalColumn: "Total",
      orderHistoryPanelDateCreatedColumn: "Order Date",
      "Discount code": "Discount code",
      "No discount applied": "No discount applied",
      "Add discount": "Add discount",
      cancelPanelTitle: "Cancel Subscription",
      cancelPanelAlertMessage: "Are you sure you want to cancel your subscription?",
      CANCELPANELCANCELSUBSCRIPTIONFLOWCANCELSUBSCRIPTIONBUTTON: "Cancel Subscription",
      cancelPanelCancelSubscriptionFlowCancelSubscriptionButton: "End Subscription",
      cancelPanelCancelSubscriptionFlowWarningHeaderMessage: "Canceling your subscription will affect future deliveries.",
      cancelPanelCancelSubscriptionFlowReactivateSubscriptionMessage: "You can reactivate your subscription anytime.",
      cancelPanelCancelSubscriptionFlowKeepSubscriptionButton: "Keep Subscription",
      cancelPanelCancelSubscriptionFlowCancelSubscriptionConfirmationButton: "Cancel Subscription Now",
      cancelSubscriptionSuccessMessage: "Your subscription was successfully canceled.",
      viewInactiveSubscriptionsButton: "View Inactive Subscriptions",
      hideInactiveSubscriptionsButton: "Hide Inactive Subscriptions",
      viewInactiveSubscriptionsTitle: "Inactive Subscriptions",
      viewInactiveSubscriptionsMessage: "Here you’ll find subscriptions you paused or canceled.",
      inactiveSubscriptionsTitle: "Inactive Subscriptions",
      inactiveSubscriptionName: "Inactive Subscription",
      inactiveSubscriptionsCount: "{{count}} inactive subscriptions",
      reactivateSubscriptionButton: "Reactivate Subscription"
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const pathname = window.location.pathname.toLowerCase();
  const isEnglish = pathname.startsWith('/en') || pathname.includes('/en/');
  const selectedLanguage = isEnglish ? 'en' : 'de';

  window.BOLD = window.BOLD || {};
  window.BOLD.subscriptions = window.BOLD.subscriptions || {};
  window.BOLD.subscriptions.config = window.BOLD.subscriptions.config || {};

  window.BOLD.subscriptions.config.language = selectedLanguage;

  const trySetLanguage = () => {
    if (window.BOLD.subscriptions.changeLanguage) {
      window.BOLD.subscriptions.changeLanguage(selectedLanguage);
    } else {
      console.warn('changeLanguage-Funktion nicht verfügbar. Retry in 500ms...');
      setTimeout(trySetLanguage, 500);
    }
  };

  trySetLanguage();
});
